"use client";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ClipboardList, Lightbulb, Rocket } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurApproach() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const steps = [{
    icon: ClipboardList,
    title: "Assess & Organize",
    description: "We evaluate your current operations and structure a clear, actionable plan tailored to your goals.",
    ref: ref1,
    isVisible: isVisible1,
    delay: "0ms"
  }, {
    icon: Lightbulb,
    title: "Strategize & Execute",
    description: "Our team implements strategic solutions and project management systems that drive measurable progress.",
    ref: ref2,
    isVisible: isVisible2,
    delay: "30ms"
  }, {
    icon: Rocket,
    title: "Accelerate & Scale",
    description: "We connect you with the resources, relationships, and infrastructure needed to achieve sustainable growth.",
    ref: ref3,
    isVisible: isVisible3,
    delay: "60ms"
  }];
  return <section className="bg-dark-background text-foreground-dark py-24 px-6">
      <div className="mx-auto max-w-3xl">
        <h2 className="mb-12 text-center font-display text-4xl font-bold">Our Approach</h2>
        <div className="flex flex-col gap-8">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <div key={i} data-index={i} ref={step.ref} style={{
            opacity: step.isVisible ? 1 : 0,
            transform: step.isVisible ? "translateY(0)" : "translateY(1rem)",
            transition: `opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) ${step.delay}, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) ${step.delay}`
          }}>
                <Card className="group cursor-pointer bg-dark-background border border-muted/30 hover:shadow-medium transition-all duration-[150ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1">
                  <CardHeader>
                    <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-md bg-primary/10">
                      <Icon className="h-7 w-7 text-primary transition-transform duration-[150ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.02]" />
                    </div>
                    <CardTitle className="text-2xl text-foreground-dark">{step.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-foreground-dark/80 leading-relaxed">
                      {step.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}